import { useNavigate } from "react-router-dom";

export function Logo({ size = "md", clickable = true, className = "" }) {
  const navigate = useNavigate();

  const sizes = {
    sm: { icon: "w-7 h-7", text: "text-base", gap: "gap-1.5" },
    md: { icon: "w-8 h-8", text: "text-lg", gap: "gap-2" },
    lg: { icon: "w-10 h-10", text: "text-xl", gap: "gap-2.5" },
  };

  const s = sizes[size] || sizes.md;

  const content = (
    <>
      <img src="/logo.svg" alt="WebGenerator" className={s.icon} />
      <span className={`font-bold tracking-tight ${s.text}`}>
        <span className="text-slate-900">Web</span>
        <span className="text-indigo-600">Generator</span>
      </span>
    </>
  );

  if (clickable) {
    return (
      <button
        onClick={() => navigate("/")}
        className={`flex items-center ${s.gap} ${className}`}
        data-testid="header-logo"
      >
        {content}
      </button>
    );
  }

  return (
    <div className={`flex items-center ${s.gap} ${className}`} data-testid="header-logo">
      {content}
    </div>
  );
}
